import { API_ATTENDANCE_URL, API_BASIC_URL } from '@/constants'
import { ILeavePolicy, ILeavePolicyDetail, ILeaveQuota, ILeaveRequest, IPaginationParam, IPaginationResponse } from '@/types'
import { createAxiosInstance } from '@/utils'
import { GenericAbortSignal } from 'axios'

const axios = createAxiosInstance({ baseURL: API_ATTENDANCE_URL, withAuth: true })
const axiosBasic = createAxiosInstance({ baseURL: API_BASIC_URL, withAuth: true })

/**
 * Leave Policy
 *
 */
export const fetchLeavePolicies = (params?: IPaginationParam & { employeeId?: string }, signal?: GenericAbortSignal) => {
  return axiosBasic
    .get<{ data: IPaginationResponse<ILeavePolicy> }>(`/leave-policy`, { params, signal })
    .then((response) => response.data.data)
}

export const createLeavePolicy = (payload: Record<string, any>) => {
  return axiosBasic.post<{ data: ILeavePolicy }>(`/leave-policy`, payload).then((response) => response.data.data)
}

export const updateLeavePolicy = (id: string, payload: Record<string, any>) => {
  return axiosBasic.put<{ data: ILeavePolicy }>(`/leave-policy/${id}`, payload).then((response) => response.data.data)
}

export const deleteLeavePolicy = (id: string) => {
  return axiosBasic.delete(`/leave-policy/${id}`).then((response) => response.data.data)
}

export const fetchLeavePolicy = (id: string) => {
  return axiosBasic.get<{ data: ILeavePolicyDetail }>(`/leave-policy/${id}`).then((response) => response.data.data)
}

export const downloadLeavePolicy = () => {
  return axios
    .get(`/leave-policy/export`, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return response
    })
}

/**
 * Leave Quota
 *
 */
export const fetchLeaveQuotas = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axiosBasic
    .get<{ data: IPaginationResponse<ILeaveQuota> }>(`/leave-quota`, { params, signal })
    .then((response) => response.data.data)
}

export const createLeaveLog = (payload: Record<string, any>) => {
  return axiosBasic.post<{ data: ILeaveQuota }>(`/leave-log`, payload).then((response) => response.data.data)
}

export const updateLeaveQuota = (id: string, payload: Record<string, any>) => {
  return axiosBasic.patch<{ data: ILeaveQuota }>(`/leave-quota/${id}`, payload).then((response) => response.data.data)
}

export const downloadLeaveQuota = (payload?: Record<string, any>) => {
  return axios
    .get(`/leave-quota/export`, {
      params: payload,
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return response
    })
}

/**
 * Leave Request
 *
 */
export const fetchLeaveRequest = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axiosBasic
    .get<{ data: IPaginationResponse<ILeaveRequest> }>(`/leave-request`, { params, signal })
    .then((response) => response.data.data)
}

export const fetchLeaveRequestDetail = (id: string) => {
  return axiosBasic.get<{ data: ILeaveRequest }>(`/leave-request/${id}`).then((response) => response.data.data)
}

export const approveLeaveRequest = (id: string, data?: { status?: string; rejectedReason?: string }) => {
  return axiosBasic.patch(`/leave-request/approval/${id}`, data)
}

export const createLeaveRequest = (payload: Record<string, any>) => {
  return axiosBasic.post<{ data: ILeaveRequest }>(`/leave-request`, payload).then((response) => response.data.data)
}

export const updateLeaveRequest = (id: string, payload: Record<string, any>) => {
  return axiosBasic.put<{ data: ILeaveRequest }>(`/leave-request/${id}`, payload).then((response) => response.data.data)
}

export const downloadLeaveRequest = () => {
  return axios
    .get(`/leave-request/export`, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return response
    })
}
